import React from 'react'
import './Contact.css'
import Section from '../section/Section'
import ContactForm from '../contactForm/ContactForm'
import { useScrollReveal } from '../../hooks/useScrollReveal'
import { useMagnetic } from '../../hooks/useMagnetic'
import { trackEvent } from '../../lib/analytics'
import linkedin from '../../images/social/linkedin.png'
import github from '../../images/social/github.png'
import instagram from '../../images/social/instagram.png'

const Contact = () => {
  const linksRef = useScrollReveal({ y: 20, stagger: 0.1 })
  const githubMagnetRef = useMagnetic()
  const linkedinMagnetRef = useMagnetic()
  const instagramMagnetRef = useMagnetic()

  return (
    <Section title="Contato" stage="contato">
      <div className="mini-ide">
        <div className="mini-ide-tabbar">
          <span className="mini-ide-tab mini-ide-tab-active">
            <span className="mini-ide-tab-dot" aria-hidden="true" />
            sendMessage.js
          </span>
        </div>
        <div className="mini-ide-body">
          <ContactForm />
        </div>
        <div className="mini-ide-statusbar">
          <span>⑂ main</span>
          <span>aguardando sua mensagem…</span>
        </div>
      </div>
      <div className="links" ref={linksRef}>
        <a
          ref={githubMagnetRef}
          href="https://github.com/jardersilva"
          target="_blank"
          rel="noopener noreferrer"
          data-reveal-item
          onClick={() =>
            trackEvent('social_click', { network: 'github', location: 'contact' })
          }
        >
          <img src={github} alt="Github Logo" width="40px" />
        </a>
        <a
          ref={linkedinMagnetRef}
          href="https://www.linkedin.com/in/jardersilva/"
          target="_blank"
          rel="noopener noreferrer"
          data-reveal-item
          onClick={() =>
            trackEvent('social_click', { network: 'linkedin', location: 'contact' })
          }
        >
          <img src={linkedin} alt="Linkedin Logo" width="40px" />
        </a>
        <a
          ref={instagramMagnetRef}
          href="https://www.instagram.com/jarder.dev/"
          target="_blank"
          rel="noopener noreferrer"
          data-reveal-item
          onClick={() =>
            trackEvent('social_click', {
              network: 'instagram',
              location: 'contact',
            })
          }
        >
          <img src={instagram} alt="Instagram Logo" width="40px" />
        </a>
      </div>
    </Section>
  )
}

export default Contact
